export default "/images/6e60c27e3741bb9e796f31b798ef8580.avif";